import { Button, withStyles, Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import supplementationService from "../../supplementationService";
import SupplementationFormCard from "./components/supplementationFormCard";
import * as actions from "redux/actions";
import { connect } from "react-redux";
import AlertIcon from "@material-ui/icons/WarningTwoTone";
import PageTitle from "../shared/pageTitle";
import { useTranslations } from "adapters/i18n";
import { DATE_FORMATS, DATE_UNIT, DateUtils } from "shared/dateUtils";
const SupplementationEditionContainer = ({
  notifySuccess,
  notifyError,
  history,
  loading,
  classes,
  match,
}) => {
  const { t } = useTranslations();
  const { params } = match;
  const [formIsValid, setFormIsValid] = useState(true);
  const [values, setValues] = useState({});

  const submit = async () => {
    try {
      loading(true);

      let amountTroughBags = values.amountTroughBags;
      if (amountTroughBags !== null && amountTroughBags !== undefined) {
        amountTroughBags = amountTroughBags.toString();
        amountTroughBags = Number(amountTroughBags.replace(",", "."));
      }
      values.amountTroughBags = amountTroughBags;
      const result = await supplementationService.updateSupplementation(
        params.supplementationId,
        values
      );
      if (result) {
        notifySuccess({
          mensagem: t("success:supplementation.successfully-saved"),
        });
        history.push(`/coletas/suplementacao/${params.supplementationId}`);
      } else {
        throw new Error(t("errors:supplementation.send-request"));
      }
    } catch (error) {
      console.log(error);
      notifyError({
        mensagem: t("errors:supplementation.update-request")
      });
    } finally {
      loading(false);
    }
  };

  const onGoBack = () => {
    history.push(`/coletas/suplementacao/`);
  };

  return (
    <div className={classes.container}>
      <PageTitle title={t("common:edit-collect")} onGoBack={onGoBack} />
      <div className={classes.txtAlertContainer}>
        <AlertIcon className={classes.iconAlert} />
        <span className={classes.txtAlert}>
          {t("common:edition-alert-text")}
          {DateUtils.now().add(1, DATE_UNIT.DAY).format(DATE_FORMATS["DD/MM/YYYY"])}.
        </span>
      </div>
      <SupplementationFormCard
        supplementationId={params.supplementationId}
        onFormValidation={setFormIsValid}
        onChangeValues={setValues}
      />
      <div className={classes.buttonBox}>
        <Tooltip
          classes={{ tooltip: classes.tooltip }}
          title={
            formIsValid
              ? t("common:fill-all-fields-to-save")
              : ""
          }
          arrow
          placement="left"
        >
          <div className={classes.buttonContainer}>
            <Button
              color="primary"
              variant="contained"
              className={classes.buttonSave}
              disabled={formIsValid}
              onClick={submit}
            >
              {t("common:actions.save-edition")}
            </Button>
          </div>
        </Tooltip>

        <div className={classes.buttonContainer}>
          <Button
            className={classes.buttonCancel}
            variant="outlined"
            color="primary"
            onClick={history.goBack}
          >
            {t("common:actions.cancel")}
          </Button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: "65px 40px 40px",
    background: "#fff",
  },
  buttonBox: {
    marginTop: "134px",
    display: "flex",
    flexDirection: "row-reverse",
  },
  buttonContainer: {
    width: "157px",
    marginLeft: "16px",
  },
  buttonCancel: {
    width: "100%",
  },
  buttonSave: {
    width: "100%",
  },
  tooltip: {
    width: "210px",
    height: "76px",
    padding: "16px",
    borderRadius: "4px",
    backgroundColor: "#616161",
    fontFamily: "Roboto",
    fontSize: "14px",
  },
  iconAlert: {
    color: "#f44336",
  },
  txtAlertContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
    marginTop: "33px",
  },
  txtAlert: {
    margin: "0 0 0 8px",
    fontFamily: "Roboto",
    fontSize: "16px",
    lineHeight: "1.44",
    letterSpacing: "0.2px",
    textAlign: "left",
    color: "#333",
  },
};

const mapDispatchToProps = {
  notifySuccess: actions.notifySuccess,
  notifyError: actions.notifyError,
  loading: actions.exibirCarregandoSalvando,
};

const mapStateToProps = ({ fazenda }) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SupplementationEditionContainer));
